<style lang="scss" scoped>
.login-form {
  .captcha-box {
    padding-right: 90px;
    position: relative;

    &__handler {
      position: absolute;
      right: 0;
      top: 0;

      &-img {
        border: solid 1px #dedede;
        border-radius: 3px;
        height: 35px;
        margin-top: -2px;
        vertical-align: middle;
        width: 100%;
      }

      &-text {
        display: inline-block;
        width: 60px;
      }
    }
  }

  .cursor {
    cursor: pointer;
  }
}

</style>
<template>
    <el-form
        class="login-form"
        ref="formData"
        :model="formData"
        :rules="formDataRule"
        action="."
        label-width="175px"
        :label-position="labelPosition"
        style="margin-top: 16px;">
        <el-form-item :label="$t('i18n.account')" prop="account">
            <el-input
                v-focus
                v-model.trim="formData.account"
                :placeholder="$t('i18n.accountPla')"
                maxlength="255"></el-input>
        </el-form-item>
        <el-form-item :label="$t('i18n.password')" prop="password">
            <el-input
                @keyup.13.native="$emit('keyup-submit')"
                onpaste="return false;"
                :type="pwdType"
                auto-complete="off"
                v-model.trim="formData.password"
                :placeholder="$t('i18n.pwdPlaceholder')"
                maxlength="255">
                <span
                    slot="suffix"
                    @click="pwdType === 'password' ? pwdType = 'text' : pwdType = 'password'">
                    <svg-i
                        class="pwd-icon cursor"
                        :icon="pwdType === 'password' ? 'icon-biyan' : 'icon-kaiyan'"></svg-i>
                </span>
            </el-input>
        </el-form-item>
        <!--
        <el-form-item :label="$t('i18n.captcha')" prop="geetest" v-show="false">
            <sweet-gt-captcha
                ref="geetest"
                :action="g.action"
                :width="'100%'"
                :product="'bind'"
                @onClose="gOnClose"
                @onError="gOnError"
                @onReset="gReset"
                @initError="gInitError"
                @onSuccess="gOnSuccess"
                :lang="$store.state.language" v-if="refreshGeetest"></sweet-gt-captcha>
        </el-form-item>
        -->
    </el-form>
</template>
<script>
// import sweetGtCaptcha from 'sweet-gt-captcha';

export default {
  name: 'loginForm',
  // components: {
  //   sweetGtCaptcha,
  // },
  props: {
    formData: {
      type: Object,
    },
    formDataRule: {
      type: Object,
    },
  },
  data() {
    // 极验证初始数据，用于重置数据初始化
    const gBase = {
      action: '/api/deed_captcha',
      initResult: '',
      validate: false,
    };
    return {
      labelPosition: window.matchMedia('(min-width: 400px)').matches ? 'right' : 'top',
      pwdType: 'password',
      // gBase,
      // g: JSON.parse(JSON.stringify(gBase)),
      // refreshGeetest: true,
    };
  },
  watch: {
    '$store.state.language': () => {
      this.refreshInitGeetest();
    },
  },
  methods: {

    gReset() {
      console.log('gReset');
      this.g = { ...this.gBase };
    },

    gOnClose() {
      console.log('gOnClose');
    },

    gOnError(res) {
      // 极验证详情错误码见@/assets/md/geetest.md文档
      if (res.code && res.code === 'error_1021') this.refreshInitGeetest(); // SESSION过期
      else if (res.error_code && res.error_code === 1021) {
        // 初始化后如果网络异常会出现1021错误码（每8分钟极验证会发起一个reset.php的xhr）
        this.refreshInitGeetest();
        this.$message({
          showClose: true,
          message: res.error_msg,
          type: 'warning',
        });
      } else if (res.error_code !== 1001 && res.error_code !== 1012) {
        // 1001 刷新次数过多 1021 拖动图像拼合错误次数过多
        this.$message({
          showClose: true,
          message: res.error_msg,
          type: 'warning',
        });
      }
    },

    gOnSuccess({ result, validate }) {
      this.formData.challenge = result.geetest_challenge;
      this.g.initResult = result;
      this.g.validate = validate;
      this.$emit('onLogin');
    },

    gInitError() {
      console.log('gInitError');
    },

    reset() {
      this.$refs.geetest.reset();
      this.g = JSON.parse(JSON.stringify(this.gBase));
    },

    refreshInitGeetest() {
      this.refreshGeetest = false;
      this.$nextTick(() => {
        this.refreshGeetest = true;
      });
    },

    verify() {
      // this.$refs.geetest.verify();
      this.$emit('onLogin');
    },
  },
};

</script>
